export class CIP
{
	constructor()
	{
		this.calcTimeout = null; // Для debounce
		this.init();
	}

	init()
	{
		// Debounced функция для calcCIP
		const debouncedCalcCIP = () => {
			clearTimeout(this.calcTimeout);
			this.calcTimeout = setTimeout(() => {
				this.calcCIP('.cip-form');
			}, 300); // 300ms задержка - достаточно для группировки множественных событий
		};

		// Добавляем события на все инпуты формы CIP
		$(document).on('change', '.cip-form input, .cip-form select', (e) => {
			this.cipChanged();
			debouncedCalcCIP();
		});

		// События для радиокнопок типа CIP
		$(document).on('change', '.cip-form input[name="cip_type"]', (e) => {
			this.cipChanged();
			debouncedCalcCIP();
		});

		// События для datepicker
		$(document).on('change', '.cip-form .datepicker__value', (e) => {
			this.cipChanged();
			debouncedCalcCIP();
		});

		// События для guests picker
		$(document).on('change', '.cip-form .guests-picker__adults-input', (e) => {
			this.cipChanged();
			debouncedCalcCIP();
		});

		$(document).on('change', '.cip-form .guests-picker__kids-item-select', (e) => {
			this.cipChanged();
			debouncedCalcCIP();
		});
	}

	calcCIP (parent)
	{
		let _this = this;
		let form = $(parent);

		//form.find('.form__loader').addClass('active');

		setTimeout(function(){
			$.ajax({
				url: "/ajax.php?mid=37&action=calcCIP",
				type: 'POST',
				data: form.serialize(),
				dataType: "html",
				success: function(html){
					$('.cip-results').html(html);
					$('.cip-results__info-block').fadeIn();
					//form.find('.form__loader').removeClass('active');
				},
				error: function(err){
					if (err.statusText === "abort") {
				// Запрос был прерван, можно просто проигнорировать
				console.warn('Запрос был прерван.');
			} else {
				// Обработка остальных ошибок
				alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
			}
				}
			});
		}, 450);

		
	}

	cipChanged()
	{
		if ($('.cip-form__answer').text() != '')
		{
			$('.cip-form__answer').fadeOut();
		}
	}
}